// /src/components/ProtectedRoute.jsx
import React, { useContext } from "react";
import { Navigate, useLocation, Outlet } from "react-router-dom";
import { AuthContext } from "../context/AuthContext";

const ProtectedRoute = () => {
  const { isAuthenticated, isLoading } = useContext(AuthContext);
  const location = useLocation();

  // If AuthContext is still doing its initial check, show a loader
  if (isLoading) {
    return <div>Loading session...</div>; 
  }

  // If the check is done and user is NOT logged in, redirect to login
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // If user is authenticated, render the child routes (Outlet)
  return <Outlet />;
};

export default ProtectedRoute;